import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Approved background image (served from public/) with a soft overlay for readability.
const bg = `${process.env.PUBLIC_URL || ''}/background.png`;
document.body.style.backgroundImage =
  `linear-gradient(rgba(238,242,248,0.92), rgba(238,242,248,0.94)), url(${bg})`;

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// ── Service worker: offline shell, and an update the user can see ───────────
// The worker caches the app but never the API. When a new version is deployed
// it waits rather than swapping mid-task, and this banner offers the reload —
// so a deploy always reaches people, visibly, instead of silently or not at all.
function showUpdateBanner(onReload) {
  if (document.getElementById('sw-update-banner')) return;
  const bar = document.createElement('div');
  bar.id = 'sw-update-banner';
  bar.setAttribute('role', 'status');
  bar.style.cssText = [
    'position:fixed', 'left:50%', 'transform:translateX(-50%)', 'bottom:18px',
    'z-index:9999', 'background:#0E1B47', 'color:#fff', 'border-radius:10px',
    'padding:11px 14px', 'display:flex', 'align-items:center', 'gap:12px',
    'font:500 13px/1.4 "DM Sans",system-ui,sans-serif',
    'box-shadow:0 8px 28px rgba(0,0,0,.28)', 'max-width:92vw',
  ].join(';');
  const text = document.createElement('span');
  text.textContent = 'A new version of the portal is available.';
  const btn = document.createElement('button');
  btn.textContent = 'Reload';
  btn.style.cssText = 'background:#fff;color:#0E1B47;border:none;border-radius:7px;' +
    'padding:7px 14px;font:600 13px "DM Sans",system-ui,sans-serif;cursor:pointer;flex:0 0 auto';
  btn.onclick = () => { btn.disabled = true; btn.textContent = 'Reloading…'; onReload(); };
  const later = document.createElement('button');
  later.textContent = 'Later';
  later.style.cssText = 'background:none;color:#B9C4E0;border:none;font-size:12.5px;cursor:pointer';
  later.onclick = () => bar.remove();
  bar.append(text, btn, later);
  document.body.appendChild(bar);
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/service-worker.js`)
      .then(reg => {
        // A worker sitting in "waiting" means a newer build is ready.
        const promptFor = worker => showUpdateBanner(() => {
          worker.postMessage({ type: 'SKIP_WAITING' });
        });
        if (reg.waiting && navigator.serviceWorker.controller) promptFor(reg.waiting);
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            // controller present = this is an update, not the first install.
            if (nw.state === 'installed' && navigator.serviceWorker.controller) promptFor(nw);
          });
        });
        // Check again when the tab is brought back, so a long-open tab notices.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') reg.update().catch(() => {});
        });
      })
      .catch(err => console.warn('Service worker registration failed:', err.message));

    // The new worker took over — load the new build exactly once.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
